import { OPTIONS } from '@/components/Layout/Menu/HeaderV2/components/NewAiHeaderButton/NewAiHeaderButton.types';
import {
  IconMail,
  IconPicture,
  IconSearch,
  IconSites,
  IconStarMoving,
  IconDashboard,
  IconSupport,
  IconMenu,
  IconAdd,
  IconAiPencil,
  IconClock,
  IconGlobeCursor,
  IconServer,
  IconBag,
} from 'gatorcomponents';
import React from 'react';
import step2Es from '@/media/guide/AiGuide/step2_es.png';
import step3Es from '@/media/guide/AiGuide/step3_es.png';

export default {
  welcome: name => (
    <div>
      <span>
        {`Hola, ${name}. `}
      </span>
      ¿Qué quieres que haga hoy?
    </div>
  ),
  compactHeader: {
    greeting: name => `Hola, ${name}. ¿Qué puedo resolver para ti ahora?`,
    greetingNoName: '¡Hola! ¿Qué puedo resolver para ti ahora?',
    placeholder: '¿Tienes una duda o necesitas ayuda? Habla conmigo',
    newGatorTag: 'Nuevo Gator 2.0',
    notificationText: 'Más rápido, más inteligente y fácil de usar. Preguntó. Resolvió',
    notificationTextShort: 'Conoce más',
    notificationAlerts: { tag: 'Tienes pendientes', text: 'Verifica y resuelve ahora', textShort: 'Resuelve ahora' },
    notificationTickets: { tag: 'Tienes tickets', text: 'Sigue tus tickets abiertos' },
    audio: {
      recordingLabel: 'Escuchando...',
      transcribingLabel: 'Transcribiendo…',
    },
    chips: {
      site: { label: 'Crear sitio', message: 'Ayúdame a crear un nuevo sitio web' },
      email: { label: 'Crear e-mail', message: 'Ayúdame a crear un correo profesional' },
      marketing: { label: 'Marketing', message: 'Lista las formas en que puedes ayudarme con marketing' },
      support: { label: 'Soporte', message: 'Necesito soporte' },
    },
    suggestionsLabel: 'Sugerencias',
    suggestions: [
      'Cómo aumentar la seguridad de mi sitio web',
      'Crear contenidos para mi negocio',
      'Analizar tendencias de innovación de un sector',
      'Sugerir mejoras para mi sitio web',
    ],
    expandedChips: {
      domainPurchase: { label: 'Contratar dominio', message: 'Quiero contratar un dominio' },
      domainConfig: { label: 'Configurar dominio', message: 'Ayúdame a configurar mi dominio' },
      checkAccount: { label: 'Revisar mi cuenta', message: 'Haz un diagnóstico de mi cuenta' },
      contractProduct: { label: 'Contratar producto', message: 'Quiero contratar un nuevo producto' },
    },
    learnMoreLabel: 'Conoce más sobre el Gator 2.0',
  },
  topbarHeader: {
    placeholder: '¿Cómo puedo ayudarte?',
    placeholderMobile: 'Pregúntale algo a Gator',
    audio: {
      recordingLabel: 'Escuchando...',
      transcribingLabel: 'Transcribiendo…',
    },
    chips: {
      site: { label: 'Crear sitio', message: 'Ayúdame a crear un nuevo sitio web' },
      email: { label: 'Crear e-mail', message: 'Ayúdame a crear un correo profesional' },
      support: { label: 'Soporte', message: 'Necesito soporte' },
    },
    expandedChips: {
      domainPurchase: { label: 'Contratar dominio', message: 'Quiero contratar un dominio' },
      domainConfig: { label: 'Configurar dominio', message: 'Ayúdame a configurar mi dominio' },
      checkAccount: { label: 'Revisar mi cuenta', message: 'Haz un diagnóstico de mi cuenta' },
      contractProduct: { label: 'Contratar producto', message: 'Quiero contratar un nuevo producto' },
    },
    suggestionsLabel: 'Sugerencias',
    suggestions: [
      'Cómo aumentar la seguridad de mi sitio web',
      'Crear contenidos para mi negocio',
      'Analizar tendencias de innovación de un sector',
      'Sugerir mejoras para mi sitio web',
    ],
    learnMoreLabel: 'Conoce el nuevo Gator',
  },
  presentationModal: {
    slides: [
      {
        title: 'Nuevo Gator con soporte más rápido',
        description: 'Entiende mejor tu duda y te ayuda a llegar a la solución sin rodeos.',
      },
      {
        title: 'Nuevo Gator con más tecnología',
        description: 'Base de conocimiento más amplia, memoria avanzada y modelos de IA de punta. Historial de mensajes, tablas, listas y mucho más.',
      },
      {
        title: 'El nuevo Gator te ayuda en tu negocio',
        description: 'Resuelve todo sobre tu sitio web, dominio, correo, alojamiento, marketing y lo que necesites.',
      },
    ],
    ctaLabel: 'Quiero probar el Nuevo Gator',
    closeLabel: 'Cerrar',
    nextLabel: 'Avanzar',
  },
  suggestions: 'Sugerencias para que empieces',
  options: [
    {
      icon: IconPicture,
      label: 'Crear un nuevo sitio web',
      initialMessage: 'Ayúdame a crear un nuevo sitio web',
      action: 'newSite',
    },
    {
      icon: IconSites,
      label: 'Configurar mi dominio',
      initialMessage: 'Configura mi dominio',
      action: 'domainConfig',
    },
    {
      icon: IconMail,
      label: 'Crea un correo profesional',
      initialMessage: 'Ayúdame a crear un correo profesional',
      action: 'email',
    },
    {
      icon: IconSearch,
      label: 'Resolver pendencias',
      action: 'openAlerts',
    },
  ],
  askMaiaPlaceholder: 'Pregúntale al Gator...',
  genericLoadingMessage: 'Analizando la mejor manera de ayudar...',
  name: 'Gator',
  tag: 'Beta',
  tooltips: {
    alerts: 'Resolver pendencias',
    minify: 'Minimizar',
    close: 'Cerrar',
    shrink: 'Reducir',
    fullScreen: 'Pantalla completa',
    settings: 'Configuraciones',
    closeDocument: 'Cerrar documento',
    closeAlerts: 'Cerrar pendencias',
    delete: 'Eliminar',
    cantDelete: alertTitle => `NNo es posible eliminar la pendencia "${alertTitle}"`,
    delay: 'Recordar más tarde',
    copyText: 'Copiar texto',
    likeAnswer: 'Me gustó la respuesta',
    dislikeAnswer: 'Necesita mejorar',
  },
  popover: {
    groupOptions: 'Opciones',
    groupSettings: 'Configuraciones',
    groupUseful: 'Enlaces útiles',
    close: 'Cerrar chat del Gator',
    sidebar: 'Cambiar chat a pantalla lateral',
    settings: 'Configuraciones',
  },
  loadingMessages: {
    default: [
      { text: 'Generando algo útil para ti.', duration: 3000 },
      { text: 'Procesando datos con cuidado.', duration: 3000 },
      { text: 'Creando la mejor respuesta posible.', duration: 3000 },
      { text: 'Analizando todo para ayudarte.', duration: 3000 },
      { text: 'Refinando ideas para ti.', duration: 3000 },
      { text: 'Pensando en la solución ideal.', duration: 3000 },
      { text: 'Organizando información importante ahora.', duration: 3000 },
      { text: 'Elaborando una respuesta valiosa.', duration: 3000 },
      { text: 'Preparando algo realmente relevante.', duration: 3000 },
    ],
  },
  marketingPlanTitle: 'Plan de marketing',
  sitePreview: 'Vista previa del sitio',
  showMaiaOnInit: 'Abrir Gator automáticamente',
  audioRecording: {
    recordingLabel: 'Escuchando...',
    transcribingLabel: 'Generando Transcripción...',
  },
  ratingSurveyLabel: 'El Gator siempre está aprendiendo y puede cometer errores. Revisa las respuestas. ',
  whatAiCouldDo: 'Mira lo que Gator puede hacer por ti',
  viewFullImage: 'Ampliar imagen',
  headerLocale: {
    options: [
      {
        label: 'Crear sitio',
        value: OPTIONS.CREATE_SITE,
        message: 'Ayúdame a crear un nuevo sitio web',
        Icon: IconDashboard,
      },
      {
        label: 'Crear correo',
        value: OPTIONS.CREATE_EMAIL,
        message: 'Ayúdame a crear un correo profesional',
        Icon: IconMail,
      },
      {
        label: 'Contratar dominio',
        value: OPTIONS.DOMAIN_PURCHASE,
        message: 'Quiero contratar un dominio',
        Icon: IconAdd,
      },
      {
        label: 'Marketing',
        value: OPTIONS.MARKETING_TIPS,
        message: 'Enumera las formas en las que puedes ayudarme con marketing',
        Icon: IconStarMoving,
        hidden: true,
      },
      {
        label: 'Soporte',
        value: OPTIONS.SUPPORT,
        message: 'Necesito apoyo',
        Icon: IconSupport,
      },
      {
        label: 'Más',
        value: OPTIONS.MORE,
        Icon: IconMenu,
      },
      {
        label: 'Configurar dominio (DNS)',
        value: OPTIONS.CONFIGURE_DOMAIN,
        message: 'Configura mi dominio',
        showMoreOptions: true,
        Icon: IconSites,
      },
      {
        label: 'Revisar mi cuenta',
        value: OPTIONS.CHECK_ACCOUNT,
        message: 'Haz un diagnóstico de mi cuenta',
        showMoreOptions: true,
      },
      {
        label: 'Crear publicaciones',
        value: OPTIONS.CREATE_POSTS,
        message: 'Ayúdame a crear mensajes para publicaciones en redes sociales',
        showMoreOptions: true,
        Icon: IconAiPencil,
        hidden: true,
      },
      {
        label: 'Contratar producto',
        value: OPTIONS.CONTRACT_PRODUCT,
        message: 'Quiero contratar un nuevo producto',
        showMoreOptions: true,
        Icon: IconBag,
      },
    ],
    actions: 'Acciones',
    talkToMaia: 'Pregunta o pídele al Gator que haga algo...',
    talkToMaiaMobile: 'Conversa con Gator...',
    alreadyOpened: 'Ya tienes un chat abierto con el Gator',
    recordingLabel: 'Escuchando...',
    transcribingLabel: 'Generando Transcripción...',
  },
  ratingSurveyCta: '¿Cómo fue usar el Gator?',
  whatAiCouldDoMessage: '¿Cómo puedes ayudarme?',
  privacyPolicy: 'Política de privacidad',
  termsOfUse: 'Términos de uso',
  homeGuideLocale: {
    steps: [
      {
        img: 'developStep1',
        salute: name => `Hola, ${name}. ¡Estoy aquí para ayudarle!`,
        title: '¡Hola! Soy Gator, tu nuevo agente de IA.',
        description: 'Estoy aquí para crear tu sitio web, configurar tu correo o dominio, crear contenidos y mucho más.',
      },
      {
        img: step2Es,
        title: '¡Déjamelo a mí!',
        description: 'Puedo configurar tu dominio, crear correos electrónicos, instalar WordPress. Solo dime qué necesitas o elige uno de las opciones rápidas aquí al lado.',
      },
      {
        img: step3Es,
        title: 'Estoy presente en todo el Portal del Cliente',
        description: 'Puedes encontrarme en la parte superior de cualquier página del portal. Solo tienes que escribir o hablar conmigo.',
      },
    ],
    currentStep: ({ current, total }) => `${current + 1} de ${total}`,
    nextCta: 'Siguiente',
    gotItCta: 'Entendido',
  },
  alerts: {
    title: 'Pendencias',
    emptyTitle: 'No hay pendencias en este momento',
    emptyDescription: 'Cuando surgieren nuevas pendencias, podrás resolverlas con la ayuda del Gator.',
    defaultGatorMessage: 'Confirma al lado las pendencias de tus productos y elige una para que te ayude a avanzar en tus objetivos.',
    'website-not-created': {
      title: 'Crea tu sitio web ahora',
      Icon: IconDashboard,
      description: 'Pon tu idea en minutos y comienza a atraer clientes.',
      createSiteOptionLabel: 'Quiero crear sitio para el dominio: ',
      actionLabel: 'Criar Sitio Web',
      htmlMessage: '<p>Elige abajo en qué dominio quieres crear tu sitio: </p>',
      severity: 'warning',
    },
    'domain-not-configured': {
      Icon: IconSites,
      title: 'Domínio no configurado',
      description: 'Seu domínio já está registrado, mas ainda não foi conectado ao site.',
      configureDomainOptionLabel: 'Ayúdame a configurar mi dominio: ',
      actionLabel: 'Configurar dominio',
      htmlMessage: '<p>A continuación se enumeran sus dominios que aún no están configurados. Elija uno de ellos para continuar: </p>',
      severity: 'critical',
    },
    createEmail: {
      title: 'E-mail profesional no creado',
      Icon: IconMail,
      description: 'Un endereço @seudomínio transmite más credibilidad. Crear ahora?',
      actionLabel: 'Criar E-mail',
      severity: 'critical',
    },
    temporaryDomain: {
      id: 'temporary-domain',
      Icon: IconClock,
      title: ({ days = 7 }) => `Domínio temporal en uso hace ${days} días`,
      description: 'Configure já um domínio próprio e dê mais credibilidade ao seu negócio.',
      actionLabel: 'Configurar',
      severity: 'warning',
    },
    validateDomain: {
      id: 'validate-domain',
      Icon: IconGlobeCursor,
      title: 'Valide su dominio internacional',
      description: 'Confirme sua compra para evitar bloqueios ou a perda do domínio.',
      actionLabel: 'Confirmar dominio',
      severity: 'critical',
    },
    serverCapacity: {
      id: 'server-capacity',
      Icon: IconServer,
      title: 'Su servidor alcanzó el 80% de la capacidad de archivos.',
      description: 'Organize seus conteúdos agora para evitar bloqueios no seu site.',
      actionLabel: 'Gerenciar',
      severity: 'critical',
    },
    toast: {
      successDelay: '¡Perfecto! Te avisaremos sobre esta pendencia en otro momento.',
      successDelete: 'Pendencia eliminada.',
      notAllowed: ({ list, amount }) => `Atención: La${amount > 1 ? 's' : ''} pendencia${amount > 1 ? 's' : ''} ${list} no puede${amount > 1 ? 'n' : ''} ser eliminada${amount > 1 ? 's' : ''}.`,
      undoCta: 'Deshacer',
    },
  },
  alertsCta: {
    label: (
      <>
        {'Tienes '}
        <strong>pendencias</strong>
      </>
    ),
    cta: 'Resolver ahora',
    ctaSolve: 'Resolver pendencias',
  },
  supportTicketsCta: {
    label: count => (
      <>
        {'Tienes '}
        <strong>{`${count} solicitud${count > 1 ? 'es' : ''} abierta${count > 1 ? 's' : ''}.`}</strong>
      </>
    ),
    cta: 'Ver solicitudes',
  },
};
